(function () {
  'use strict';
  var configNode = document.querySelector('[data-cart-config]');
  if (!configNode || !window.fetch || !window.FormData) return;
  var config = JSON.parse(configNode.textContent);
  var pending = false;
  var noticeTimer;
  var text = config.text;

  function url(path) { return config.root.replace(/\/?$/, '/') + path; }
  function announce(message, error) {
    var notice = document.querySelector('[data-cart-notice]');
    var status = document.querySelector('[data-cart-status]');
    var alert = document.querySelector('[data-cart-error]');
    clearTimeout(noticeTimer);
    status.textContent = '';
    alert.textContent = '';
    (error ? alert : status).textContent = message;
    notice.querySelector('[data-cart-message]').textContent = message;
    notice.classList.toggle('is-error', !!error);
    notice.hidden = false;
    if (!error) noticeTimer = setTimeout(function () { notice.hidden = true; }, 5000);
  }

  function updateCount(cart) {
    if (!cart || !Number.isInteger(cart.item_count)) throw new Error(text.uncertain);
    document.querySelectorAll('[data-cart-link]').forEach(function (link) {
      link.setAttribute('aria-label', text.cartLabel.replace('__COUNT__', cart.item_count));
      var count = link.querySelector('[data-cart-count]');
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    });
  }

  function unknownCount() {
    document.querySelectorAll('[data-cart-link]').forEach(function (link) {
      link.setAttribute('aria-label', text.openCart);
      var count = link.querySelector('[data-cart-count]');
      count.textContent = '…';
      count.hidden = false;
    });
  }

  async function request(path, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(url(path), Object.assign({ credentials: 'same-origin', cache: 'no-store', signal: controller.signal }, options));
      var data = await response.json();
      if (!response.ok || data.status >= 400) {
        var message = typeof data.description === 'string' ? data.description : text.error;
        throw new Error(message + ' ' + text.review);
      }
      return data;
    } catch (error) {
      if (error instanceof TypeError || error.name === 'AbortError' || error instanceof SyntaxError) throw new Error(text.uncertain);
      throw error;
    } finally {
      clearTimeout(timer);
    }
  }

  async function syncCount() {
    var cart = await request('cart.js');
    updateCount(cart);
    return cart;
  }

  function snapshot(form, button) {
    var panel = form.closest('[data-product-form]');
    var id = form.querySelector('[name="id"]').value;
    var variants = JSON.parse(panel.querySelector('[data-variants-json]').textContent);
    var variant = variants.find(function (item) { return String(item.id) === id; });
    var photo = variant && variant.featured_image;
    var gallery = panel.parentElement.querySelector('[data-gallery-main-img]');
    var source = gallery && gallery.getBoundingClientRect();
    if (!source || source.bottom < 0 || source.top > window.innerHeight) source = button.getBoundingClientRect();
    return {
      src: typeof photo === 'string' ? photo : photo && photo.src,
      rect: source,
      label: panel.querySelector('.product-title').textContent.trim() + (variant && variant.title !== 'Default Title' ? ' · ' + variant.title : '')
    };
  }

  function flyToCart(photo, added) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = Array.from(document.querySelectorAll('[data-cart-link]')).find(function (link) {
      var r = link.getBoundingClientRect();
      return r.width > 0 && r.top >= 0 && r.bottom <= window.innerHeight;
    });
    var src = added.featured_image && added.featured_image.url || added.image || photo.src;
    if (!target || !src || !Element.prototype.animate) return;
    var end = target.getBoundingClientRect();
    var size = 64;
    var left = Math.min(Math.max(photo.rect.left + photo.rect.width / 2 - size / 2, 8), window.innerWidth - size - 8);
    var top = Math.min(Math.max(photo.rect.top + photo.rect.height / 2 - size / 2, 8), window.innerHeight - size - 8);
    var bubble = document.createElement('img');
    bubble.className = 'cart-flight';
    bubble.src = src;
    bubble.alt = '';
    bubble.setAttribute('aria-hidden', 'true');
    bubble.style.left = left + 'px';
    bubble.style.top = top + 'px';
    document.body.appendChild(bubble);
    var dx = end.left + end.width / 2 - left - size / 2;
    var dy = end.top + end.height / 2 - top - size / 2;
    var animation = bubble.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 50) + 'px) scale(.8)', opacity: 1, offset: .5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0 }
    ], { duration: 700, easing: 'cubic-bezier(.22,.61,.36,1)' });
    var cleanup = function () { bubble.remove(); };
    animation.onfinish = function () {
      cleanup();
      target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }], { duration: 250 });
    };
    animation.oncancel = cleanup;
    setTimeout(cleanup, 1200);
  }

  function restoreAddButton(form, button) {
    form.removeAttribute('aria-busy');
    var panel = form.closest('[data-product-form]');
    var variants = JSON.parse(panel.querySelector('[data-variants-json]').textContent);
    var current = variants.find(function (v) { return String(v.id) === form.querySelector('[name="id"]').value; });
    button.disabled = !current || !current.available;
    button.textContent = current && current.available ? button.dataset.addText : current ? button.dataset.soldOutText : button.dataset.unavailableText;
  }

  async function add(form, button) {
    if (pending || button.disabled || !form.reportValidity()) return;
    var data = new FormData(form);
    var quantity = Number(data.get('quantity') || 1);
    if (!data.get('id') || !Number.isInteger(quantity) || quantity < 1) { announce(text.quantityError, true); return; }
    var photo = snapshot(form, button);
    pending = true;
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = text.adding;
    try {
      var added = await request('cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      if (!added || (!added.id && !added.items)) throw new Error(text.uncertain);
      var confirmed = added.items ? added.items[0] : added;
      var message = text.added.replace('__PRODUCT__', photo.label);
      try { await syncCount(); } catch (_) { unknownCount(); message += ' ' + text.countPending; }
      announce(message, false);
      try { flyToCart(photo, confirmed); } catch (_) { }
    } catch (error) {
      try { await syncCount(); } catch (_) { unknownCount(); }
      announce(error.message || text.uncertain, true);
    } finally {
      pending = false;
      restoreAddButton(form, button);
    }
  }

  function lockCart(root, locked) {
    root.setAttribute('aria-busy', String(locked));
    root.querySelectorAll('button,input').forEach(function (control) { control.disabled = locked || root.dataset.cartStale === 'true'; });
    root.querySelectorAll('[data-cart-remove]').forEach(function (link) { link.setAttribute('aria-disabled', String(locked || root.dataset.cartStale === 'true')); });
  }

  function parseSection(html) {
    if (typeof html !== 'string') return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
  }

  async function renderCart(root, cart, focusIndex, focusQuantity) {
    var id = root.dataset.sectionId;
    var replacement = parseSection(cart.sections && cart.sections[id]);
    if (!replacement) {
      var sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('section_id', id);
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch(sectionUrl.toString(), { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (response.ok) replacement = parseSection(await response.text());
      } finally {
        clearTimeout(timer);
      }
    }
    if (!replacement) throw new Error(text.refresh);
    root.replaceWith(replacement);
    var targets = replacement.querySelectorAll(focusQuantity ? '[data-cart-qty]' : '[data-cart-remove]');
    var target = targets[Math.min(focusIndex, targets.length - 1)] || replacement.querySelector('h1');
    if (target) target.focus({ preventScroll: true });
  }

  async function change(root, line, quantity, focusQuantity) {
    if (pending || root.dataset.cartStale === 'true') return;
    var input = line.querySelector('[data-cart-qty]');
    if (!Number.isInteger(quantity) || quantity < 0) { input.value = input.defaultValue; announce(text.quantityError, true); return; }
    var key = line.dataset.lineKey;
    var index = Array.from(root.querySelectorAll('[data-cart-line]')).indexOf(line);
    pending = true;
    lockCart(root, true);
    var confirmed = false;
    try {
      var cart = await request('cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [root.dataset.sectionId], sections_url: window.location.pathname })
      });
      if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count)) throw new Error(text.uncertain);
      confirmed = true;
      updateCount(cart);
      await renderCart(root, cart, index, focusQuantity);
      announce(quantity === 0 ? text.removed : text.updated, false);
    } catch (error) {
      var reconciled = false;
      try {
        var fresh = await syncCount();
        await renderCart(root, fresh, index, focusQuantity);
        reconciled = true;
      } catch (_) { }
      if (!reconciled) root.dataset.cartStale = 'true';
      announce(confirmed ? text.refresh : error.message || text.uncertain, true);
    } finally {
      pending = false;
      if (root.isConnected) lockCart(root, false);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.closest('[data-cart-section]') && (pending || form.closest('[data-cart-section]').dataset.cartStale === 'true')) { event.preventDefault(); return; }
    if (!form.closest('[data-product-form]')) return;
    if (event.submitter && event.submitter.name !== 'add') return;
    var button = form.querySelector('[data-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    add(form, button);
  });

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-cart-dismiss]');
    if (close) { document.querySelector('[data-cart-notice]').hidden = true; return; }
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    change(remove.closest('[data-cart-section]'), remove.closest('[data-cart-line]'), 0, false);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (input) change(input.closest('[data-cart-section]'), input.closest('[data-cart-line]'), Number(input.value), true);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncCount().catch(unknownCount);
  });
})();
